import "./axiosInstance";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "react-toastify/dist/ReactToastify.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "./store/AuthContext";
import { RouterProvider } from "react-router-dom";
import { router } from "./router";
import { AppContextProvider } from "./Context";

export { axios } from "./axiosInstance";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <AppContextProvider>
        <RouterProvider router={router} />
      </AppContextProvider>
    </AuthProvider>
  </React.StrictMode>
);

reportWebVitals();
